// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

export const toSafeUri = str => {
  let uri = str.toString().toLowerCase().replace(/(^\w+:|^)\/\//, '');
  return `https://${uri}`;
};

export const validateCpf = (cpf, intl) => {
  if (!cpf) {
    return intl.formatMessage({
      id: 'SignupForm.cpfRequired'
    });
  }

  let invalid = intl.formatMessage({ id: 'SignupForm.cpfInvalid' });

  const cleanCpf = cpf.replace(/[^\d]/g, '');

  if (cleanCpf.length !== 11) {
    return invalid;
  }

  if (/^(\d)\1{10}$/.test(cleanCpf)) {
    return invalid;
  }

  let sum = 0;
  let rest;
  for (let i = 0; i < 9; i++) {
      sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
  }
  rest = 11 - (sum % 11);
  const firstVerificatorChar = rest === 10 || rest === 11 ? 0 : rest;

  if (firstVerificatorChar !== parseInt(cleanCpf.charAt(9))) {
    return invalid;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
  }
  rest = 11 - (sum % 11);
  const secondVerificatorChar = rest === 10 || rest === 11 ? 0 : rest;

  if (secondVerificatorChar !== parseInt(cleanCpf.charAt(10))) {
    return invalid;
  }

  return undefined;
};
